import React, { useState, useEffect, useCallback } from "react";
import {
  Container, Paper, Typography, Button, TextField, Table, TableBody, TableCell,
  TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogContent,
  DialogActions, Switch, FormControlLabel, Chip, makeStyles
} from "@material-ui/core";
import { Add, Edit, Delete } from "@material-ui/icons";
import { getSLAPolicies, createSLAPolicy, updateSLAPolicy, deleteSLAPolicy } from "../../services/api.new-features";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2) },
  paper: { padding: theme.spacing(2), marginTop: theme.spacing(2) },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center" },
}));

const SLAManagement = () => {
  const classes = useStyles();
  const [policies, setPolicies] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [current, setCurrent] = useState({});

  const load = useCallback(async () => {
    try {
      const res = await getSLAPolicies({});
      setPolicies(res.data.slaPolicies || res.data);
    } catch (e) { toast.error("Erro ao carregar SLA"); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleSave = async () => {
    try {
      if (current.id) { await updateSLAPolicy(current.id, current); }
      else { await createSLAPolicy(current); }
      setDialog(false); setCurrent({}); load();
      toast.success("Política SLA salva!");
    } catch (e) { toast.error("Erro ao salvar"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Excluir política SLA?")) return;
    try { await deleteSLAPolicy(id); load(); } catch (e) { toast.error("Erro"); }
  };

  const formatTime = (minutes) => {
    if (minutes < 60) return `${minutes}min`;
    return `${Math.floor(minutes / 60)}h ${minutes % 60}min`;
  };

  return (
    <Container maxWidth="lg" className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h5">Gerenciamento de SLA</Typography>
        <Button variant="contained" color="primary" startIcon={<Add />}
          onClick={() => { setCurrent({ firstResponseMinutes: 30, resolutionMinutes: 480, isActive: true }); setDialog(true); }}>
          Nova Política</Button>
      </div>

      <Paper className={classes.paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Prioridade</TableCell>
              <TableCell>1ª Resposta</TableCell>
              <TableCell>Resolução</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {policies.map(p => (
              <TableRow key={p.id}>
                <TableCell>{p.name}</TableCell>
                <TableCell><Chip size="small" label={p.priority || "Todas"} /></TableCell>
                <TableCell>{formatTime(p.firstResponseMinutes)}</TableCell>
                <TableCell>{formatTime(p.resolutionMinutes)}</TableCell>
                <TableCell>
                  <Chip size="small" label={p.isActive ? "Ativo" : "Inativo"}
                    style={{ backgroundColor: p.isActive ? "#4caf50" : "#9e9e9e", color: "#fff" }} />
                </TableCell>
                <TableCell>
                  <IconButton size="small" onClick={() => { setCurrent(p); setDialog(true); }}><Edit /></IconButton>
                  <IconButton size="small" onClick={() => handleDelete(p.id)}><Delete /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={dialog} onClose={() => setDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{current.id ? "Editar Política SLA" : "Nova Política SLA"}</DialogTitle>
        <DialogContent>
          <TextField fullWidth margin="dense" label="Nome" value={current.name || ""}
            onChange={e => setCurrent({ ...current, name: e.target.value })} />
          <TextField fullWidth margin="dense" label="Prioridade (ex: urgent, high)" value={current.priority || ""}
            onChange={e => setCurrent({ ...current, priority: e.target.value })} />
          <TextField fullWidth margin="dense" label="Tempo 1ª Resposta (minutos)" type="number"
            value={current.firstResponseMinutes || ""} onChange={e => setCurrent({ ...current, firstResponseMinutes: Number(e.target.value) })} />
          <TextField fullWidth margin="dense" label="Tempo Resolução (minutos)" type="number"
            value={current.resolutionMinutes || ""} onChange={e => setCurrent({ ...current, resolutionMinutes: Number(e.target.value) })} />
          <FormControlLabel control={
            <Switch checked={!!current.isActive} onChange={e => setCurrent({ ...current, isActive: e.target.checked })} />
          } label="Ativo" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog(false)}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained" color="primary">Salvar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default SLAManagement;